import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { IEventBus } from "@/domains/events"
import { EventEmitter, makeGroupId } from "@/domains/library"
import { LockTokensWithdrawnEvent } from "@/domains/lock/events"

import type { IWithdrawTokensFromExpiredVeActions } from "./interfaces"

interface WithdrawTokensFromExpiredVeInteractionParams {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  tokenId: number
  emitter: EventEmitter<EmitEvent> | undefined
  eventBus: IEventBus
  onChainActions: IWithdrawTokensFromExpiredVeActions
}

export const withdrawTokensFromExpiredVeInteraction = async ({
  account,
  chainId,
  config,
  vestedAddress,
  tokenId,
  emitter,
  eventBus,
  onChainActions,
}: WithdrawTokensFromExpiredVeInteractionParams) => {
  // Generate a unique group ID for this interaction instance
  const groupId = makeGroupId("withdraw-tokens-from-expired-ve")

  const result = await onChainActions.withdrawTokensFromExpiredVe({
    account,
    chainId,
    config,
    vestedAddress,
    tokenId,
  })

  if (result.success) {
    eventBus.publish(new LockTokensWithdrawnEvent(groupId, tokenId, result.tx))
    if (emitter) {
      emitter.emit("withdraw-tokens-from-expired-ve", {
        title: "Withdraw Tokens from Expired NFT",
        description: `Tokens withdrawn from NFT #${tokenId}`,
        variant: "success",
      })
    }
    return result
  }

  if (result.success === false) {
    if (emitter) {
      emitter.emit("error-withdrawing-tokens-from-expired-ve", {
        title: "Withdraw Tokens from Expired NFT failed",
        description: `Unable to withdraw tokens NFT`,
        variant: "error",
      })
    }
    return false
  }

  return result
}
